import React from 'react';
import Layout from "../components/App/Layout"
import SEO from "../components/App/SEO"
import NavbarStyleTwo from '../components/App/NavbarStyleTwo';
import PageBanner from '../components/Common/PageBanner';
import Footer from '../components/App/Footer';

import StartProjectWithUs from '../components/Common/StartProjectWithUs';

import VisionServicesImg1 from '../assets/images/vision-ai/1.png'
import VisionServicesImg2 from '../assets/images/vision-ai/2.png'
import VisionServicesImg3 from '../assets/images/vision-ai/3.png'


const SingleServices = () => {
    return (
        <Layout>
            <SEO title="Vision AI - Human Pose Detection & Object Detection" description="Build mobile and web applications embedded with deeplearning frameworks that are capable of holistic human detection, dynamic object detection, text detection & much more." />

			<NavbarStyleTwo />

			<PageBanner 
                pageTitle="Vision AI" 
            /> 

            <div className="overview-area ptb-100">
                <div className="container">
                    <div className="overview-box">
                        
                    <div className="overview-content">
                            <div className="content right-content">
                                <span className="sub-title">Real-time Face,Hand & Pose Prediction</span>
                                <h2>Holistic Human Detection</h2>
                                <p>Build cutting-edge mobile and web applications embedded with advanced deep learning frameworks that help in holistic human pose estimation</p>
                                <ul className="features-list">
                                    <li><span><i className='bx bx-check'></i> Human Pose Detection</span></li>
                                    <li><span><i className='bx bx-check'></i> Face Detection & Recognition</span></li>
                                    <li><span><i className='bx bx-check'></i>Hand Gesture Tracking</span></li>
                                    <li><span><i className='bx bx-check'></i> Ergonomic Risk Analysis</span></li>

                                </ul>
                            </div>
                        </div>

                        <div className="overview-image">
                            <div className="image">
                                <img src={VisionServicesImg1} alt="Cimplify Holistic Human Detection" />
                            </div>
                        </div>
                    </div>

                    <div className="overview-box">
                        <div className="overview-image">
                            <div className="image">
                                <img src={VisionServicesImg2} alt="Cimplify Dynamic Object Detection" />
                            </div>
                        </div>
                        
                        <div className="overview-content">
                            <div className="content right-content">
                                <span className="sub-title">Streamline Operations with Computer Vision</span>
                                <h2>Dynamic Object Detection</h2>
                                <p>Introduce object detection algorithms in existing applications or build standalone object detection solutions with the help of deep learning frameworks</p>
                                <ul className="features-list">
                                    <li><span><i className='bx bx-check'></i> Product Defect identification </span></li>
                                    <li><span><i className='bx bx-check'></i> Tumor Detection </span></li>
                                    <li><span><i className='bx bx-check'></i> Medical Imaging</span></li>
                                    <li><span><i className='bx bx-check'></i> Automated Object Counting</span></li>
                                
                                    

                                </ul>
                            </div>
                        </div>
                        <div className="overview-box">
                        
                        <div className="overview-content">
                                <div className="content right-content">
                                    <span className="sub-title">Automate Text Tasks with Vision AI</span>
                                    <h2>Text Detection & Analysis</h2>
                                    <p>Enhance process efficiency and streamline workflows by introducing text detection, extraction and analysis frameworks in applications.</p>
                                    <ul className="features-list">
                                        <li><span><i className='bx bx-check'></i> Text Detection & Extraction </span></li>
                                        <li><span><i className='bx bx-check'></i> Form Extraction </span></li>
                                        <li><span><i className='bx bx-check'></i> Invoice Data Extraction</span></li>
                                        <li><span><i className='bx bx-check'></i> Document Digitization</span></li>

                                    </ul>
                                </div>
                            </div>
    
                            <div className="overview-image">
                                <div className="image">
                                    <img src={VisionServicesImg3} alt="Cimplify Text Detection & Analysis" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="services-area bg-f9f9f9 pt-100 pb-70">
                <div className="container">
                    <div className="section-title">
                        <span className="sub-title">Computer Vision Applications</span>
                        <h2>Core Application Areas</h2>
                        <p>Here are a few areas where Vision AI can be used to improve efficiency and drive productivity.</p>
                    </div>

                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-services-box">
                                <div className="icon ">
                                    <i className="bx bx-run"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Fitness & Sports</h3>
                                <p>Technique analysis - stance, stroke & footwork, performance analysis, biomechanics, injury prevention, ball tracking & more.</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-car"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Traffic & Public Welfare</h3>
                                <p>Real-time traffic monitoring, vehicle tracking, pedestrian safety, infrastructure monitoring, smart parking & more.</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-clinic"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Healthcare</h3>
                                <p>Digital physiotherapy, diagnostic intelligence, prescription assistance, prediction engines, early detection systems & more.</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-bot"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Manufacturing</h3>
                                <p>Quality inspection & control, equipment monitoring, predictive maintenance, defect detection, object identification & more.</p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-slideshow"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Media & Entertainment</h3>
                                <p>Video annotation, metadata extraction, auto tagging, video content search, celebrity identification & more. </p>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 col-sm-6">
                            <div className="single-services-box">
                                <div className="icon">
                                    <i className="bx bx-shopping-bag"></i>
                                    <div className="circles-box">
                                        <div className="circle-one"></div>
                                        <div className="circle-two"></div>
                                    </div>
                                </div>
                                <h3>Retail</h3>
                                <p> Virtual try-on, footfall analysis, in-store advertising, customer behaviour analysis, product recognition, & more.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        

            <StartProjectWithUs />
			  
			<Footer />
		</Layout>
    )
}

export default SingleServices;